import Constant from '@/const';
import axios from 'axios';

const putLabRequest = async ({ payload, id_lab }) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/supportservice/laboratory/request/${id_lab}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putLabRequest;
